import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Tooltip,
} from '@material-ui/core';
import { DeleteOutline as DeleteOutlineIcon } from '@material-ui/icons';
import { setMessage } from '../../store/authSlice';
import { deleteCompany } from '../../store/companySlice';

const useStyles = makeStyles((theme) => ({
  submitButton: {
    borderRadius: 50,
    minWidth: 0,
    width: 'auto',
    padding: 2,
    margin: theme.spacing(0, 0.5),
    position: 'relative',
  },
}));

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

// eslint-disable-next-line no-unused-vars
export default function DeleteCompanyModal({ companyId }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAccept = () => {
    dispatch(deleteCompany({ companyId }))
      .unwrap()
      .then(() => {
        dispatch(setMessage({ message: 'Company deleted', severity: 'success' }));
        handleClose();
      })
      .catch(() => {
        dispatch(setMessage({ message: 'Company could not be deleted', severity: 'error' }));
      });
  };

  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          Do you want delete company #
          {companyId}
          ?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            This action will persist the deletion of this company on the database.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button variant="contained" onClick={handleAccept} color="primary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Tooltip title="Delete Company">
        <Button
          variant="contained"
          color="primary"
          size="small"
          className={classes.submitButton}
          onClick={handleOpen}
        >
          <DeleteOutlineIcon fontSize="small" />
        </Button>
      </Tooltip>
    </>
  );
}
